module.exports = __webpack_public_path__ + "media/Components/Logos/upload-fe0ce1bd62e276af74bb8b1e1a44f7e4.svg";